export class PayerTypeFilter {
    public IncludeInactive?: boolean;
}

export default PayerTypeFilter;